export const SUBSCRIBER_RESERVED_LABEL = 'Reserva da assinante';

export type CompositionProductReservationFields = {
  campaignName?: string | null;
  campaign_name?: string | null;
  isSubscriberReserved?: boolean | string | number | null;
  is_subscriber_reserved?: boolean | string | number | null;
  reserved?: boolean | string | number | null;
  reservedCampaignName?: string | null;
  reservedForSubscriber?: boolean | string | number | null;
  reserved_campaign_name?: string | null;
  reserved_for_subscriber?: boolean | string | number | null;
  subscriberReserved?: boolean | string | number | null;
  subscriber_reserved?: boolean | string | number | null;
};

function isTrueFlag(value: unknown): boolean {
  return (
    value === true ||
    value === 'true' ||
    value === 'TRUE' ||
    value === 1 ||
    value === '1'
  );
}

function nonEmptyString(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed ? trimmed : undefined;
}

function asReservationFields(
  product: unknown
): CompositionProductReservationFields | null {
  if (!product || typeof product !== 'object') {
    return null;
  }
  return product as CompositionProductReservationFields;
}

export function subscriberReservedCampaignName(
  product: unknown
): string | undefined {
  const fields = asReservationFields(product);
  if (!fields) {
    return undefined;
  }
  return (
    nonEmptyString(fields.reservedCampaignName) ||
    nonEmptyString(fields.reserved_campaign_name) ||
    nonEmptyString(fields.campaignName) ||
    nonEmptyString(fields.campaign_name)
  );
}

export function isSubscriberReservedProduct(product: unknown): boolean {
  const fields = asReservationFields(product);
  if (!fields) {
    return false;
  }
  if (
    isTrueFlag(fields.subscriberReserved) ||
    isTrueFlag(fields.reservedForSubscriber) ||
    isTrueFlag(fields.isSubscriberReserved) ||
    isTrueFlag(fields.subscriber_reserved) ||
    isTrueFlag(fields.reserved_for_subscriber) ||
    isTrueFlag(fields.is_subscriber_reserved)
  ) {
    return true;
  }
  // `reserved` as a number is stock reservation qty, not this tag.
  if (
    fields.reserved === true ||
    fields.reserved === 'true' ||
    fields.reserved === 'TRUE'
  ) {
    return true;
  }
  return !!subscriberReservedCampaignName(fields);
}

export function subscriberReservedLabel(product: unknown): string {
  return isSubscriberReservedProduct(product) ? SUBSCRIBER_RESERVED_LABEL : '';
}

export function subscriberReservedTooltip(product: unknown): string {
  if (!isSubscriberReservedProduct(product)) {
    return '';
  }
  const campaign = subscriberReservedCampaignName(product);
  return campaign
    ? `${SUBSCRIBER_RESERVED_LABEL} — ${campaign}`
    : SUBSCRIBER_RESERVED_LABEL;
}

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function subscriberReservedChipHtml(product: unknown): string {
  if (!isSubscriberReservedProduct(product)) {
    return '';
  }
  const tooltip = escapeHtml(subscriberReservedTooltip(product));
  return `<span class="subscriber-reserved-chip" title="${tooltip}">${SUBSCRIBER_RESERVED_LABEL}</span>`;
}
